import { NftDetails, MoleMeta } from '../types'

export const RARITY_LEVEL_MAP: Record<MoleMeta['rarity'], number> = {
  common: 1,
  special: 2,
  rare: 3,
  epic: 4,
  legendary: 5,
}

export const sortMoles = (moles: NftDetails[]) => {
  return moles.sort((a, b) => {
    const aRarityLevel = RARITY_LEVEL_MAP[a.rarity]
    const bRarityLevel = RARITY_LEVEL_MAP[b.rarity]
    if (aRarityLevel && bRarityLevel && aRarityLevel !== bRarityLevel) {
      return bRarityLevel - aRarityLevel
    }
    return parseInt(a.id) - parseInt(b.id)
  })
}

export const sortNfts = (nfts: NftDetails[]) => {
  return nfts.sort((a, b) => {
    return parseInt(a.id) - parseInt(b.id)
  })
}
